import { get, post } from 'axios';

/**
 * Redeem a code and register the a new student
 * @param  {String} token - instant redemption token
 * @param  {Object} registrant_info - Registrant information
 * @return {Boolean} - True if successful, false otherwise
 */
export const getHomepageData = async () => {
    try {
        const response = await get('/homepage', {});

        // if response status is not 200, move to catch block
        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return {
            status: response.status,
            data: response.data
        };
    }
    catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : 'Something went wrong. Please try again.'
        };
    }
};
export const getSuitesJSON = async (currentPage, paginateNumber) => {
    currentPage = parseInt(currentPage) > 0 ? parseInt(currentPage) : 1;
    paginateNumber = parseInt(paginateNumber) > 0 ? parseInt(paginateNumber) : 25;
    try {
        const response = await get('/suites-json/' + currentPage + '/' + paginateNumber, {});

        // if response status is not 200, move to catch block
        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return {
            status: response.status,
            data: response.data
        };
    }
    catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : 'Something went wrong. Please try again.'
        }
    }
};

export const getSlides = async (slides, items, pg, limit, include, usage) => {
    let response;
    try {
        response = await get(`/slides/${slides}/items/${items}/pg/${pg}/limit/${limit}?include=${include}&filter[use]=${usage}`);

        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return {
            status: response.status,
            data: response.data
        };

    } catch (error) {
        return {
            status: (response.status) ? response.status : 500,
            message: error ? error : "Something went wrong. Please try again."
        };
    }
}

export const getProductPageData = async (pathName, productId, productSlug) => {
    let response;
    try {
        response = await get('/' + pathName + '/' + productId + '/' + productSlug);

        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return {
            status: response.status,
            data: response.data
        };
    }

    catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : "Something went wrong. Please try again."
        };
    }

};

/**
 * Makes a get request for the Testimonials data for Skye Learning. This is a separate route from the 
 * one that returns the HTML view in testimonials.blade.php view.
 */
export const getTestimonialsData = async (pageVar, paginateVar) => {
    try {
        const response = await get('/testimonials-page/' + pageVar + '/' + paginateVar);

        // if response status is not 200, move to catch block
        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return {
            status: response.status,
            data: response.data
        };
    }
    catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : "Something went awry. Please try again."
        };
    }
};


export const getCourseTestimonials = async (course_id, currentPage, paginateNum) => {
    try {
        const response = await get('/courses/' + course_id + '/testimonials');

        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return {
            status: response.status,
            data: response.data
        };
    }
    catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : " Something went awry. Please try again."
        };
    }
};

export const getCategoriesDomains = async (currentPage, paginateNum) => {
    try {
        const response = await get('/categories/domains');

        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return {
            status: response.status,
            data: response.data
        };
    }
    catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : " Something went awry. Please try again."
        };
    }
};

export const getBrandsDomains = async (currentPage, paginateNum) => {
    try {
        const response = await get('/brands/domains');

        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return {
            status: response.status,
            data: response.data
        };
    }
    catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : " Something went awry. Please try again."
        };
    }
};

export const getBrandProducts = async (brand_id, brand_slug = null, currentPage, paginateNum) => {
    try {
        const response = await get(`/brands/${brand_id}/${brand_slug}`);

        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return {
            status: response.status,
            data: response.data
        };
    }
    catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : " Something went awry. Please try again."
        };
    }
};

export const getBrandsCategories = async () => {
    try {
        const response = await get(`/brandscategories`);

        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return {
            status: response.status,
            data: response.data
        };
    }
    catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : " Something went awry. Please try again."
        };
    }
};

export const sendDiscountForm = async (captcha, discount_form, captcha_type = 'invisible') => {
    try {
        const response = await post('/discount-form', {
            headers: { 'Content-Type': 'application/json' },
            captcha,
            captcha_type,
            discount_form,
        });
        // if response status is not 200, move to catch block
        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return response.data;

    } catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : 'Something went wrong. Please try again.'
        };
    }

};

export const sendSurveyForm = async (work_confidence_form, captcha, captcha_type = 'invisible') => {
    try {
        const response = await post('/work-confidence-form', {
            headers: { 'Content-Type': 'application/json' },
            work_confidence_form,
            captcha,
            captcha_type
        });
        // if response status is not 200, move to catch block
        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return response.data;

    } catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : 'Something went wrong. Please try again.'
        };
    }

};

export const addToCart = async (course_id, domain_id) => {
    try {
        const response = await post('/cart/add', {
            data: {
                course_id: course_id,
                domain_id: domain_id
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // if response status is not 200, move to catch block
        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return {
            status: response.status,
            data: response.data
        };
    }
    catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : 'Something went wrong. Please try again.'
        };
    }
};

export const buyNow = async (course_id, domain_id) => {
    try {
        const response = await post('/cart/add', {
            data: {
                course_id: course_id,
                domain_id: domain_id
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // if response status is not 200, move to catch block
        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        if (response.status === 200) {
            window.location = '/checkout';
        }
    }
    catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : 'Something went wrong. Please try again.'
        };
    }
};

export const setGlobalModalState = async () => {
    try {
        const response = await post('/set-global-discount', {
            headers: { 'Content-Type': 'application/json' },
            globalDiscountState: true,
        });
        // if response status is not 200, move to catch block
        if (response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return response.data;

    } catch ({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : 'Something went wrong. Please try again.'
        };
    }

};

/**
 * Error class that, when thrown, is able to pass a response
 * object to the catch block
 */
class ApiHttpError extends Error {
    constructor(response = { status: 500 }, ...params) {
        super(...params);

        this.response = response;
    }
}